import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
// import FlagIcon from "@mui/icons-material/Flag";
import FlagIcon from "@material-ui/icons/Flag";
import {
  Add,
  Refresh,
} from "@material-ui/icons";
import InventoryStatusPopup from "./InventoryStatusPopup";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import jwtDecode from "jwt-decode";
import {
  fetchAllInventoryData,
  fetchAllLotnumbers,
  fetchAllReceivingPlantIDs,
  fetchAllRMPMCodes,
  fetchAllStorageLocationIds,
  fetchCMOMembers,
} from "../../../containers/actions/common/inventoryStatus";
import { saveInventoryStatusFilters } from "../../../containers/actions/common/inventoryStatusActions";
import { FETCH_ALL_INVENTORY_DATA_LOADING } from "../../../containers/actions/types";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete } from "@material-ui/lab";
import InventoryReconciliation from "./InventoryReconciliation";
// import ViewReconciliationHistory from "./ViewReconciliationHistory";
import usePrevious from "../../helpers/previousProps";
import CustomTableCell from "../models/table/CustomTableCell";
import { convertToLocaleDateTime } from "../functionalComponents/FormatDateTimeToLocale";
import { fetchInventoryStatusFilters } from "../../../containers/actions/common/inventoryStatusActions";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { getFeaturesAccess } from "../../../containers/actions/common/accessControl";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
    borderCollapse: "collapse",
    "& .MuiTableCell-stickyHeader": {
      backgroundColor: "#FFE4C2 ",
      BorderTop: "1px solid #ffab91",
      BorderBottom: "1px solid #ffab91",
      Height: "2rem",
    },
    "& .MuiTableCell-root": {
      padding: "8px 12px",
      lineHeight: "2.3",
      fontSize: "0.9rem",
    },
  },
  headerCell: {
    fontWeight: 500,
  },
  grayRow: {
    backgroundColor: "#f7f6f6",
  },
  spaceBetween: {
    lineHeight: "2",
  },
  lotNumbers: {
    display: "block",
    lineHeight: "1.5",
  },
  stickyHeaderRow: {
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  buttonStyle: {
    borderRadius: "5rem",
    whiteSpace: "nowrap",
    cursor: "pointer",
    backgroundColor: "#ec6535",
    color: "#fff",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#9E4D27",
      color: "#fff",
    },
  },
  savebutton: {
    borderRadius: "5rem",
    whiteSpace: "nowrap",
    cursor: "pointer",
    backgroundColor: "#ec6535",
    color: "#fff",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#9E4D27",
      color: "#fff",
    },
  },
  btnSync: {
    background:
      "transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box;",
    color: "white",
    textTransform: "none",
    borderRadius: "2rem",

    padding: "5px 20px",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
    },
  },
  btnSave: {
    textTransform: "none",
    borderRadius: "50px",
    backgroundColor: "#ec6535",
    color: "white",
    "&:hover": {
      backgroundColor: "#ec6535",
    },
  },
  centeredCell: {
    verticalAlign: "middle",
  },
  cellStyle: {
    width: "10%",
    margin: 0,
    padding: 0,
    // outline: "1px solid pink",
  },
  collapsedRow: {
    backgroundColor: "#f7f6f6",
  },
  smallGrid: {
    minWidth: 140,
    [theme.breakpoints.up('sm')]: {
      flexBasis: '13%',
      maxWidth: '13%',
    }
  },
  materialCodeGrid: {
    minWidth: 200,
    [theme.breakpoints.up('sm')]: {
      flexBasis: '18%',
      maxWidth: '18%',
    },
  },
}));



const InventoryStatusDashboard = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showTable, setShowTable] = useState(false);
  const [openRows, setOpenRows] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [reconDialog, setReconDialog] = useState(false);
  const [vendorData, setVendorData] = useState({});
  const [selectedCMO, setSelectedCMO] = useState({ organizationId: 'All', organizationName: "All" });
  const [selectedPlant, setSelectedPlant] = useState({ plantCode: 'All' });
  const [filteredMaterialCodes, setFilteredMaterialCodes] = useState([]);
  const [selectedMaterialCode, setSelectedMaterialCode] = useState({ materialCode: 'All', materialDescription: 'All' });
  const [selectedBatchNumber, setSelectedBatchNumber] = useState({ inventoryBatchNumber: 'All' });
  const [selectedStorageLocation, setSelectedStorageLocation] = useState({ storageLocationID: 'All' })
  const [filteredBatchNumbers, setFilteredBatchNumbers] = useState([]);
  const [inventoryList, setInventoryList] = useState([]);
  // const [filterLoading, setFilterLoading] = useState(false);
  // const [filter, setFilter] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20); // Default rows per page
  const [paginatedData, setPaginatedData] = useState([]);
  const [savedFilters, setSavedFilters] = useState({
    vendorPlant: "all",
    vendorName: "all",
    rmpmCodeDescription: "all",
    sponsorLotNumber: "all",
  });
  const [inventoryToggleValue, setInventoryToggleValue] = useState(localStorage.collabType === "Pharma Co" ? "BMS" : null)
  const filtersFetchedRef = useRef(false);
  const [inventorySyncTime, setInventorySyncTime] = useState(null);

  const getOrganizationIdFromToken = () => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) return null;

    try {
      const decodedToken = jwtDecode(authToken);
      return decodedToken.organization_id || null;
    } catch (error) {
      return null;
    }
  };

  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess?.data
        .inventoryReconciliationDashboard
  );

  const featuresAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.featuresAccess
        ?.inventoryReconciliationDashboardFeature
  );

  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess) {
      dispatch(
        getFeaturesAccess(
          screenAccess?.screenId,
          "inventoryReconciliationDashboardFeature"
        )
      );
    }
  }, [dispatch, screenAccess, featuresAccess]);

  const inventoryData = useSelector((state) => {
    return state?.pcmp?.common?.inventoryStatus?.inventoryStatusDetails;
  });

  const prevInventoryData = usePrevious(inventoryData);

  const inventoryDataLoading = useSelector((state) => {
    return state?.pcmp?.common?.inventoryStatus?.inventoryStatusDetailsLoading;
  });

  const cmosList = useSelector((state) => {
    return state?.pcmp?.common?.inventoryStatus?.cmosDetails;
  });

  const plantCodesList = useSelector((state) => {
    return state?.pcmp?.common?.inventoryStatus?.plantCodeDetails;
  });

  const storageLocationList = useSelector((state) => {
    return state?.pcmp?.common?.inventoryStatus?.storageLocationDetails;
  });

  const materialCodesList = useSelector((state) => {
    return state?.pcmp?.common?.inventoryStatus?.materialCodesDetails;
  });

  const lotNumbersList = useSelector((state) => {
    return state?.pcmp?.common?.inventoryStatus?.lotNumberDetails;
  });

  // const inventoryStatusSaveList = useSelector((state) => {
  //   return state?.pcmp?.common?.inventoryStatus?.inventoryStatusSaveDetails;
  // });

  useEffect(() => {
    if (JSON.stringify(inventoryData) !== JSON.stringify(prevInventoryData)) {
      setInventoryList(inventoryData);
    }

  }, [inventoryData, prevInventoryData]);

  useEffect(() => {
    if (inventoryData && inventoryData?.sponsorLatestInventorySyncTime && inventoryToggleValue === "BMS") {
      setInventorySyncTime(inventoryData?.sponsorLatestInventorySyncTime)
    } else if (inventoryData?.cmoLatestInventorySyncTime && inventoryToggleValue === "CMO") {
      setInventorySyncTime(inventoryData?.cmoLatestInventorySyncTime)
    } else if (inventoryData?.cmoLatestInventorySyncTime && localStorage.collabType === 'CMO' && inventoryToggleValue === null) {
      setInventorySyncTime(inventoryData?.cmoLatestInventorySyncTime)
    } else {
      setInventorySyncTime(null)
    }

  }, [inventoryData, inventoryToggleValue])

  let showPagination = inventoryList?.totalNoOfRecords > 0;

  useEffect(() => {
    const list = inventoryList?.inventoryDataList;
    if (!list?.length) {
      setPaginatedData(list);
      return;
    }
    const sorted = [...list].sort((a, b) =>
      (a?.vendorName ?? "").localeCompare(b?.vendorName ?? "", undefined, { sensitivity: "base" })
    );
    setPaginatedData(sorted);
  }, [inventoryList, currentPage]);

  const totalPages = inventoryList?.numberOfPages;

  const getDecodedAuthToken = () => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) return null;

    try {
      const decodedToken = jwtDecode(authToken);
      return decodedToken;
    } catch (error) {
      console.error("Error decoding JWT token:", error);
      return null;
    }
  };

  const decodedTokenData = getDecodedAuthToken();
  const organizationIdFromToken = decodedTokenData?.organization_id || null;

  useEffect(() => {
    if (localStorage.collabType !== "CMO") {
      dispatch(fetchCMOMembers());
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllReceivingPlantIDs());
    dispatch(fetchAllRMPMCodes());
    dispatch(fetchAllLotnumbers());
    dispatch(fetchAllStorageLocationIds())
  }, [dispatch]);




  useEffect(() => {

    const fetchFilters = async () => {
      // setFilterLoading(true);
      try {

        // Use the unified API to fetch filters
        const result = await dispatch(fetchInventoryStatusFilters());

        if (result && result.status && result.save_filter_options) {
          const inventoryFilters = result.save_filter_options;
          // setFilter(inventoryFilters);
          setSavedFilters(inventoryFilters);
          // Set filter UI state from fetched filters
          if (inventoryFilters && Object.keys(inventoryFilters)?.length > 0) {
            // Find complete CMO object from the list
            if (inventoryFilters.vendorName !== "all" && cmosList?.CMOMembersWithId) {
              const matchedCMO = cmosList.CMOMembersWithId.find(
                (cmo) => cmo.organizationName === inventoryFilters.vendorName
              );
              setSelectedCMO(matchedCMO || { organizationId: "All", organizationName: "All" });
            } else {
              setSelectedCMO({ organizationId: "All", organizationName: "All" });
            }

            // Find complete Plant object from the list
            if (inventoryFilters.vendorPlant !== "all" && plantCodesList?.data) {
              const matchedPlant = plantCodesList.data.find(
                (plant) => plant.plantCode === inventoryFilters.vendorPlant
              );
              setSelectedPlant(matchedPlant || { plantCode: "All" });
            } else {
              setSelectedPlant({ plantCode: "All" });
            }

            // Find complete Material Code object from the list
            if (inventoryFilters.rmpmCodeDescription !== "all" && materialCodesList?.data) {
              const matchedMaterialCode = materialCodesList.data.find(
                (material) => material.materialCode === inventoryFilters.rmpmCodeDescription
              );
              setSelectedMaterialCode(matchedMaterialCode || { materialCode: "All", materialDescription: "All" });
            } else {
              setSelectedMaterialCode({ materialCode: "All", materialDescription: "All" });
            }

            // Find complete Batch Number object from the list
            if (inventoryFilters.sponsorLotNumber !== "all" && lotNumbersList?.data) {
              const matchedBatchNumber = lotNumbersList.data.find(
                (lot) => lot.inventoryBatchNumber === inventoryFilters.sponsorLotNumber
              );
              setSelectedBatchNumber(matchedBatchNumber || { inventoryBatchNumber: "All" });
            } else {
              setSelectedBatchNumber({ inventoryBatchNumber: "All" });
            }
          } else {
            // setFilter({});
            setSelectedCMO({ organizationId: "All", organizationName: "All" });
            setSelectedPlant({ plantCode: "All" });
            setSelectedMaterialCode({ materialCode: "All", materialDescription: "All" });
            setSelectedBatchNumber({ inventoryBatchNumber: "All" });
          }
        }
      } catch (err) {
        console.error("Error fetching inventory status filters:", err);
      } finally {
        // setFilterLoading(false);
      }
    };

    // Fetch filters only after all dropdown lists are loaded and only once
    // For CMO users, cmosList is not needed, so we skip that check
    const listsLoaded = localStorage.collabType === "CMO"
      ? plantCodesList && materialCodesList && lotNumbersList
      : cmosList && plantCodesList && materialCodesList && lotNumbersList;

    if (!filtersFetchedRef.current && listsLoaded) {
      filtersFetchedRef.current = true;
      fetchFilters();
    }
  }, [dispatch, cmosList, plantCodesList, materialCodesList, lotNumbersList]);

  const handleSaveFilters = async () => {
    const filtersToSave = {
      vendorPlant: (!selectedPlant?.plantCode || selectedPlant?.plantCode === "All") ? "all" : selectedPlant?.plantCode,
      vendorName: (!selectedCMO?.organizationName || selectedCMO?.organizationName === "All") ? "all" : selectedCMO?.organizationName,
      rmpmCodeDescription: (!selectedMaterialCode?.materialCode || selectedMaterialCode?.materialCode === "All") ? "all" : selectedMaterialCode?.materialCode,
      rmpmDescription: (!selectedMaterialCode?.materialDescription || selectedMaterialCode?.materialDescription === "All") ? "all" : selectedMaterialCode?.materialDescription,
      sponsorLotNumber:
        (!selectedBatchNumber?.inventoryBatchNumber || selectedBatchNumber?.inventoryBatchNumber === "All") ? "all" : selectedBatchNumber?.inventoryBatchNumber,
      storageLocationID: (!selectedStorageLocation.storageLocationID || selectedStorageLocation.storageLocationID === "All") ? "all" : selectedStorageLocation.storageLocationID,
    };

    if (JSON.stringify(filtersToSave) !== JSON.stringify(savedFilters)) {
      setSavedFilters(filtersToSave);
      try {
        // Save filters using the unified API - only save, don't fetch data
        await dispatch(saveInventoryStatusFilters(filtersToSave));
      } catch (error) {
        console.error("Error saving filters:", error);
      }
    }
  };

  const handleRefresh = () => {
    let data = {}
    if (localStorage.collabType === "CMO") {
      data = {
        vendorMosymphonyID: localStorage.collabType === "CMO" ? getOrganizationIdFromToken() || "all" : selectedCMO?.organizationId || "all",
      }
    }
    dispatch({
      type: FETCH_ALL_INVENTORY_DATA_LOADING,
      payload: true,
    });
    dispatch(
      fetchAllInventoryData({
        [localStorage.collabType === "CMO"
          ? "brandOwnerMosymphonyID"
          : "vendorMosymphonyID"]:
          localStorage.collabType === "CMO"
            ? inventoryList?.inventoryDataList?.[0]?.brandOwnerMosymphonyID ||
            "all"
            : (!selectedCMO?.organizationId || selectedCMO?.organizationId === "All") ? "all" : selectedCMO?.organizationId,
        vendorPlant: (!selectedPlant?.plantCode || selectedPlant?.plantCode === "All") ? "all" : selectedPlant?.plantCode,
        materialCode: (!selectedMaterialCode?.materialCode || selectedMaterialCode?.materialCode === "All") ? "all" : selectedMaterialCode?.materialCode,
        inventoryBatchNumber:
          (!selectedBatchNumber?.inventoryBatchNumber || selectedBatchNumber?.inventoryBatchNumber === "All") ? "all" : selectedBatchNumber?.inventoryBatchNumber,
        storageLocationID: (!selectedStorageLocation.storageLocationID || selectedStorageLocation.storageLocationID === "All") ? "all" : selectedStorageLocation.storageLocationID,
        pageNumber: currentPage,
        pageSize: rowsPerPage,
        ...data
      })
    );
  };

  const handleClearFilters = async () => {
    setCurrentPage(1);
    setShowTable(false);
    setRowsPerPage(20);
    setSelectedMaterialCode({ materialCode: "All", materialDescription: "All" });
    setSelectedBatchNumber({ inventoryBatchNumber: "All" });
    setSelectedCMO({ organizationId: "All", organizationName: "All" });
    setSelectedPlant({ plantCode: "All" });
    setSelectedStorageLocation({ storageLocationID: "All" })
    setInventoryToggleValue(localStorage.collabType === "Pharma Co" ? "BMS" : null)
    // setFilteredMaterialCodes(materialCodesList?.data);
    // setFilteredBatchNumbers(lotNumbersList?.data );

    // Clear filters on the server by setting all to "all"
    // try {
    //   const clearedFilters = {
    //     vendorPlant: "all",
    //     vendorName: "all",
    //     rmpmCodeDescription: "all",
    //     rmpmDescription: "all",
    //     sponsorLotNumber: "all",
    //   };

    //   await dispatch(saveInventoryStatusFilters(clearedFilters));
    //   setSavedFilters(clearedFilters);
    // } catch (error) {
    //   console.error("Error clearing filters:", error);
    // }
  };

  const handleViewReport = () => {
    let data = {}
    if (localStorage.collabType === "CMO") {
      data = {
        vendorMosymphonyID: localStorage.collabType === "CMO" ? getOrganizationIdFromToken() || "all" : selectedCMO?.organizationId || "all",
      }
    }
    setShowTable(true);
    dispatch({
      type: FETCH_ALL_INVENTORY_DATA_LOADING,
      payload: true,
    });
    setCurrentPage(1);
    dispatch(
      fetchAllInventoryData({
        [localStorage.collabType === "CMO"
          ? "brandOwnerMosymphonyID"
          : "vendorMosymphonyID"]:
          localStorage.collabType === "CMO"
            ? inventoryList?.inventoryDataList?.[0]?.brandOwnerMosymphonyID ||
            "all"
            : (!selectedCMO?.organizationId || selectedCMO?.organizationId === "All") ? "all" : selectedCMO?.organizationId,
        vendorPlant: (!selectedPlant?.plantCode || selectedPlant?.plantCode === "All") ? "all" : selectedPlant?.plantCode,
        materialCode: (!selectedMaterialCode?.materialCode || selectedMaterialCode?.materialCode === "All") ? "all" : selectedMaterialCode?.materialCode,
        inventoryBatchNumber:
          (!selectedBatchNumber?.inventoryBatchNumber || selectedBatchNumber?.inventoryBatchNumber === "All") ? "all" : selectedBatchNumber?.inventoryBatchNumber,
        storageLocationID: (!selectedStorageLocation.storageLocationID || selectedStorageLocation.storageLocationID === "All") ? "all" : selectedStorageLocation.storageLocationID,
        pageNumber: 1,
        pageSize: rowsPerPage,
        ...data
      })
    );
  };

  const cmoOptions = cmosList?.CMOMembersWithId || [];
  const filteredPlantCodes =
    localStorage.collabType === "CMO"
      ? plantCodesList?.data.filter(
        (plant) => organizationIdFromToken === plant.vendorMosymphonyID
      )
      : selectedCMO && selectedCMO.organizationId !== 'All'
        ? plantCodesList?.data.filter(
          (plant) => selectedCMO?.organizationId === plant.vendorMosymphonyID
        )
        : plantCodesList?.data || [];

  const filteredStorageLocationIDs =
    localStorage.collabType === "CMO"
      ? storageLocationList?.data.filter(
        (val) => organizationIdFromToken === val.vendorMosymphonyID
      )
      : selectedCMO && selectedCMO.organizationId !== 'All'
        ? storageLocationList?.data.filter(
          (val) => selectedCMO?.organizationId === val.vendorMosymphonyID
        )
        : selectedPlant && selectedPlant.plantCode !== "All" ?
          storageLocationList?.data.filter(
            (val) => selectedPlant.plantCode === val.vendorPlant
          )
          : storageLocationList?.data ? Array.from(new Map(storageLocationList?.data.map(item => [item.storageLocationID, item])).values()) : []


  useEffect(() => {
    // Reset material code selection if CMO or Plant changes
    // setSelectedMaterialCode(null);

    if ((!selectedCMO && !selectedPlant && !selectedBatchNumber) || (selectedCMO?.organizationId === 'All' && selectedPlant?.plantCode === 'All' && selectedBatchNumber?.inventoryBatchNumber === 'All')) {
      setFilteredMaterialCodes(materialCodesList?.data);
    } else {
      const filteredData = materialCodesList?.data.filter(
        (item) =>
          (localStorage.collabType === "CMO"
            ? item.vendorMosymphonyID === organizationIdFromToken
            : !selectedCMO ||
            item.vendorMosymphonyID === selectedCMO?.organizationId) &&
          (!selectedPlant || item.vendorPlant === selectedPlant?.plantCode)
      );
      setFilteredMaterialCodes(filteredData);
    }
  }, [selectedCMO, selectedPlant, materialCodesList]);

  useEffect(() => {
    let filteredData = lotNumbersList?.data ? [...lotNumbersList.data] : [];

    if ((!selectedCMO && !selectedPlant && !selectedMaterialCode) || (selectedCMO?.organizationId === 'All' && selectedPlant?.plantCode === 'All' && selectedBatchNumber?.inventoryBatchNumber === 'All')) {
      let filteredData = lotNumbersList?.data;
      // Show all material codes when both are not selected
      setFilteredBatchNumbers(filteredData);
    }

    if (localStorage.collabType === "CMO") {
      filteredData = filteredData.filter(
        (item) => item.vendorMosymphonyID === organizationIdFromToken
      );
    } else if (selectedCMO) {
      filteredData = filteredData.filter(
        (item) => item.vendorMosymphonyID === selectedCMO?.organizationId
      );
    }

    // if (selectedCMO) {
    //   // setFilteredBatchNumbers(filteredData);
    //   filteredData = filteredData.filter(
    //     (item) => item.vendorMosymphonyID === selectedCMO?.organizationId
    //   );
    // }
    if (selectedPlant) {
      // setFilteredBatchNumbers(filteredData);
      filteredData = filteredData.filter(
        (item) => item.vendorPlant === selectedPlant?.plantCode
      );
    }
    if (selectedMaterialCode) {
      // setFilteredBatchNumbers(filteredData);
      filteredData = filteredData.filter(
        (item) => item.materialCode === selectedMaterialCode?.materialCode
      );
      // setFilteredBatchNumbers(filteredData);
    }
    if (filteredData.length > 0) {
      setFilteredBatchNumbers(filteredData);
    }
  }, [selectedCMO, selectedPlant, selectedMaterialCode, lotNumbersList]);


  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleViewInventoryToggle = () => {
    let val = inventoryToggleValue === "BMS" ? "CMO" : "BMS"
    setInventoryToggleValue(val)
  }

  const handleRowToggle = (index) => {
    setOpenRows((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const isSaveDisabled =
    (selectedCMO?.organizationName || "all") === savedFilters.vendorName &&
    (selectedPlant?.plantCode || "all") === savedFilters.vendorPlant &&
    (selectedMaterialCode?.materialCode || "all") ===
    savedFilters.rmpmCodeDescription &&
    (selectedBatchNumber?.inventoryBatchNumber || "all") ===
    savedFilters.sponsorLotNumber;

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = event.target.value;
    let data = {}
    if (localStorage.collabType === "CMO") {
      data = {
        vendorMosymphonyID: localStorage.collabType === "CMO" ? getOrganizationIdFromToken() || "all" : selectedCMO?.organizationId || "all",
      }
    }
    setRowsPerPage(newRowsPerPage);

    setCurrentPage(1); //Reset to first page
    dispatch({
      type: FETCH_ALL_INVENTORY_DATA_LOADING,
      payload: true,
    });
    dispatch(
      fetchAllInventoryData({
        [localStorage.collabType === "CMO"
          ? "brandOwnerMosymphonyID"
          : "vendorMosymphonyID"]:
          localStorage.collabType === "CMO"
            ? inventoryList?.inventoryDataList?.[0]?.brandOwnerMosymphonyID ||
            "all"
            : (!selectedCMO?.organizationId || selectedCMO?.organizationId === "All") ? "all" : selectedCMO?.organizationId,
        vendorPlant: (!selectedPlant?.plantCode || selectedPlant?.plantCode === "All") ? "all" : selectedPlant?.plantCode,
        materialCode: (!selectedMaterialCode?.materialCode || selectedMaterialCode?.materialCode === "All") ? "all" : selectedMaterialCode?.materialCode,
        inventoryBatchNumber:
          (!selectedBatchNumber?.inventoryBatchNumber || selectedBatchNumber?.inventoryBatchNumber === "All") ? "all" : selectedBatchNumber?.inventoryBatchNumber,
        storageLocationID: (!selectedStorageLocation.storageLocationID || selectedStorageLocation.storageLocationID === "All") ? "all" : selectedStorageLocation.storageLocationID,
        pageNumber: currentPage,
        pageSize: newRowsPerPage,
        ...data
      })
    );
  };

  const handlePageChange = (newPage) => {
    let data = {}
    if (localStorage.collabType === "CMO") {
      data = {
        vendorMosymphonyID: localStorage.collabType === "CMO" ? getOrganizationIdFromToken() || "all" : selectedCMO?.organizationId || "all",
      }
    }
    setCurrentPage(newPage);
    // paginateData();
    dispatch({
      type: FETCH_ALL_INVENTORY_DATA_LOADING,
      payload: true,
    });
    dispatch(
      fetchAllInventoryData({
        [localStorage.collabType === "CMO"
          ? "brandOwnerMosymphonyID"
          : "vendorMosymphonyID"]:
          localStorage.collabType === "CMO"
            ? inventoryList?.inventoryDataList?.[0]?.brandOwnerMosymphonyID ||
            "all"
            : (!selectedCMO?.organizationId || selectedCMO?.organizationId === "All") ? "all" : selectedCMO?.organizationId,
        vendorPlant: (!selectedPlant?.plantCode || selectedPlant?.plantCode === "All") ? "all" : selectedPlant?.plantCode,
        materialCode: (!selectedMaterialCode?.materialCode || selectedMaterialCode?.materialCode === "All") ? "all" : selectedMaterialCode?.materialCode,
        inventoryBatchNumber:
          (!selectedBatchNumber?.inventoryBatchNumber || selectedBatchNumber?.inventoryBatchNumber === "All") ? "all" : selectedBatchNumber?.inventoryBatchNumber,
        storageLocationID: (!selectedStorageLocation.storageLocationID || selectedStorageLocation.storageLocationID === "All") ? "all" : selectedStorageLocation.storageLocationID,
        pageNumber: newPage,
        pageSize: rowsPerPage,
        ...data
      })
    );
  };

  const brandOwnerName =
    localStorage.getItem("ecosystem_name") ||
    "";

  return (
    <div>
      <Typography
        style={{ fontSize: "1rem", fontWeight: 550, marginBottom: "0.5rem" }}
      >
        Please enter any of the following values to view the report
      </Typography>

      <Grid
        container
        spacing={2}
        style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", gap: "15px", rowGap: "15px" }}
      >
        {/* Select CMO/CDMO */}

        <Grid item xs="auto" className={classes.smallGrid}>
          {localStorage.collabType === "CMO" ? (
            <TextField
              style={{
                whiteSpace: "nowrap",
                overflowX: "auto",
                scrollbarWidth: "none", // Hide scrollbar (Firefox)
                msOverflowStyle: "none", // Hide scrollbar (IE/Edge)
              }}
              value={brandOwnerName}
              label={
                <span style={{ whiteSpace: "nowrap" }}>
                  Select BMS
                  {/* <span style={{ color: "red" }}>{" "}*</span> */}
                </span>
              }
              InputProps={{
                readOnly: true, // Make it non-editable
                style: { minWidth: "max-content" }, // Ensures full text visibility
              }}
              fullWidth
            />
          ) : (
            <Autocomplete
              style={{
                whiteSpace: "nowrap",
                overflowX: "auto",
                scrollbarWidth: "none", // Hide scrollbar (Firefox)
                msOverflowStyle: "none", // Hide scrollbar (IE/Edge)
              }}
              options={cmoOptions ? [{ organizationId: 'All', organizationName: "All" }, ...cmoOptions] : [{ organizationId: 'All', organizationName: "All" }]}
              getOptionLabel={(option) => option?.organizationName || ""}
              value={selectedCMO}
              // value={filter?.vendorName || selectedCMO}
              onChange={(event, newValue) => {
                setSelectedCMO(newValue);
                setSelectedPlant({ plantCode: 'All' }); // Clear Plant ID on CMO change
                setSelectedStorageLocation({ storageLocationID: 'All' })
                setSelectedBatchNumber({ inventoryBatchNumber: 'All' });
                setSelectedMaterialCode({ materialCode: 'All', materialDescription: 'All' });
              }}
              getOptionSelected={(option, value) =>
                option.organizationId === value.organizationId && option.organizationName === value.organizationName
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <span style={{ whiteSpace: "nowrap" }}>
                      Select CMO
                      {/* <span style={{ color: "red" }}>{" "}*</span> */}
                    </span>
                  }
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: <SearchIcon style={{ marginRight: 8 }} />,
                    style: { minWidth: "max-content" },
                  }}
                  fullWidth
                />
              )}
            />
          )}
        </Grid>

        {/* Select Plant ID */}

        <Grid item xs="auto" className={classes.smallGrid}>
          <Autocomplete
            style={{
              whiteSpace: "nowrap",
              overflowX: "auto",
              scrollbarWidth: "none", // Hide scrollbar (Firefox)
              msOverflowStyle: "none", // Hide scrollbar (IE/Edge)
            }}
            options={(filteredPlantCodes ? [{ plantCode: 'All' }, ...filteredPlantCodes] : [{ plantCode: 'All' }]).filter(
              (option) => option?.plantCode !== null && option?.plantCode !== undefined
            )}
            getOptionLabel={(option) => option?.plantCode || ""}
            value={selectedPlant}
            // value={filter.vendorPlant || selectedPlant}
            onChange={(event, newValue) => {
              setSelectedPlant(newValue);
              setSelectedStorageLocation({ storageLocationID: 'All' })
              setSelectedBatchNumber({ inventoryBatchNumber: 'All' });
              setSelectedMaterialCode({ materialCode: 'All', materialDescription: 'All' });
            }}
            getOptionSelected={(option, value) =>
              option.plantCode === value.plantCode
            }
            // disabled={!selectedCMO}
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <span style={{ whiteSpace: "nowrap" }}>
                    Select Plant ID
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </span>
                }
                InputProps={{
                  ...params.InputProps,
                  startAdornment: <SearchIcon style={{ marginRight: 8 }} />,
                }}
                fullWidth
              />
            )}
          />
        </Grid>

        {/* Select Storage Location Id */}

        <Grid item xs="auto" className={classes.smallGrid}>
          <Autocomplete
            style={{
              whiteSpace: "nowrap",
              overflowX: "auto",
              scrollbarWidth: "none", // Hide scrollbar (Firefox)
              msOverflowStyle: "none", // Hide scrollbar (IE/Edge)
            }}
            options={(filteredStorageLocationIDs ? [{ storageLocationID: 'All' }, ...filteredStorageLocationIDs] : [{ storageLocationID: 'All' }]).filter(
              (option) => option?.storageLocationID !== null && option?.storageLocationID !== undefined
            )}
            getOptionLabel={(option) => option?.storageLocationID || ""}
            value={selectedStorageLocation}
            onChange={(event, newValue) => {
              setSelectedStorageLocation(newValue);
              setSelectedBatchNumber({ inventoryBatchNumber: 'All' });
              setSelectedMaterialCode({ materialCode: 'All', materialDescription: 'All' });
            }}
            getOptionSelected={(option, value) =>
              option.storageLocationID === value.storageLocationID
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <span style={{ whiteSpace: "nowrap" }}>
                    Select Storage Location ID
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </span>
                }
                InputProps={{
                  ...params.InputProps,
                  startAdornment: <SearchIcon style={{ marginRight: 8 }} />,
                }}
                fullWidth
              />
            )}
          />
        </Grid>

        {/* Select RM/PM Code */}

        <Grid item xs="auto" className={`${classes.smallGrid} ${classes.materialCodeGrid}`}>
          <Autocomplete
            style={{
              whiteSpace: "nowrap",
              overflowX: "auto",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
            options={filteredMaterialCodes ? [{ materialCode: 'All', materialDescription: 'All' }, ...filteredMaterialCodes] : [{ materialCode: 'All', materialDescription: 'All' }]}
            // getOptionLabel={(option) => option?.materialCode || ""}
            getOptionLabel={(option) =>
              option ? option.materialCode === 'All' ? "All" : `${option.materialCode} / ${option.materialDescription}` : ""
            }
            value={selectedMaterialCode}
            // value={filter.rmpmCodeDescription || selectedMaterialCode}
            onChange={(event, newValue) => {
              setSelectedMaterialCode(newValue);
              setSelectedBatchNumber({ inventoryBatchNumber: 'All' });
            }}
            getOptionSelected={(option, value) =>
              option.materialCode === value.materialCode && option.materialDescription === value.materialDescription
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <span style={{ whiteSpace: "nowrap" }}>
                    {localStorage.collabType === "CMO" ? "Select CMO Material Code / Description" : "Select BMS Material Code / Description"}
                  </span>
                }
                InputProps={{
                  ...params.InputProps,
                  startAdornment: <SearchIcon style={{ marginRight: 8 }} />,
                }}
                fullWidth
              />
            )}
          />
        </Grid>

        {/* Select Sponsor Batch Number */}

        <Grid item xs="auto" className={classes.smallGrid}>
          <Autocomplete
            options={filteredBatchNumbers ? [{ inventoryBatchNumber: 'All' }, ...filteredBatchNumbers] : [{ inventoryBatchNumber: 'All' }]}
            getOptionLabel={(option) => option?.inventoryBatchNumber || ""}
            value={selectedBatchNumber}
            // value={filter.sponsorLotNumber || selectedBatchNumber}
            onChange={(event, value) => setSelectedBatchNumber(value)}
            getOptionSelected={(option, value) =>
              option.inventoryBatchNumber === value.inventoryBatchNumber
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <span style={{ whiteSpace: "nowrap" }}>

                    {localStorage.collabType === "CMO" ? "Select CMO Batch Number" : "Select BMS Batch Number"}
                    {/* <span style={{ color: "red" }}>{" "}*</span> */}
                  </span>
                }
                InputProps={{
                  ...params.InputProps,
                  startAdornment: <SearchIcon />,
                }}
                fullWidth
              />
            )}
          />
        </Grid>

        {/* View Report Button */}

        <Grid item xs="auto" >
          <Button className={classes.buttonStyle}
            // style={{
            //   borderRadius: "5rem",
            //   whiteSpace: "nowrap",
            //   cursor: "pointer",
            //   backgroundColor:
            //     localStorage.collabType !== "CMO" &&
            //     !selectedCMO &&
            //     !selectedPlant &&
            //     !selectedMaterialCode &&
            //     !selectedBatchNumber
            //       ? "#f4b799" 
            //       : "#ec6535",
            //   color: "#fff",
            //   textTransform: "none",
            // }}
            onClick={handleViewReport}
            disabled={
              localStorage.collabType !== "CMO" &&
              !selectedCMO &&
              !selectedBatchNumber &&
              !selectedMaterialCode &&
              !selectedPlant
            }
          >
            View Report
          </Button>
        </Grid>

        {/* Save Filters Button */}
        <Grid item xs="auto" style={{ paddingLeft: 0 }}>
          <Button className={classes.savebutton}
            // style={{
            //   borderRadius: "5rem",
            //   whiteSpace: "nowrap",
            //   cursor: "pointer",
            //   backgroundColor: "#ec6535",
            //   color: "#fff",
            //   textTransform: "none",
            // }}
            onClick={handleSaveFilters}
            disabled={isSaveDisabled}
          >
            Save Filters
          </Button>
        </Grid>
        {/* Clear All Filters */}
        <Grid item xs="auto" style={{ padding: 0 }} onClick={handleClearFilters}>
          <Typography
            variant="caption"
            style={{
              fontSize: 14,
              color: "#286ACF",
              cursor: "pointer",
              textDecoration: "underline",
              whiteSpace: "nowrap",
            }}
          >
            Clear All Filters
          </Typography>
        </Grid>
      </Grid>

      {showTable && (
        <>
          <Grid item style={{ marginTop: "1rem" }}>
            <Grid container justifyContent="flex-end">
              <Grid
                item
                style={{
                  // textDecoration: 'underline',
                  // fontStyle: 'italic',
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Typography
                  variant="body2"
                  style={{ color: "gray", marginRight: "8px" }}
                >
                  {`Last synced @ ${moment(new Date()).format(
                    "HH:mm:ss; DD MMMM, YYYY"
                  )}`}
                </Typography>
                <Grid>
                  <Typography
                    variant="body2"
                    color="primary"
                    style={{
                      textDecoration: "underline",
                      fontStyle: "italic",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={handleRefresh}
                  >
                    Refresh
                    <Refresh color="primary" fontSize="small" />
                  </Typography>
                </Grid>
              </Grid>

              <Grid
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  marginTop: "10px",
                  width: "100%",
                }}
              >
                <Typography
                  style={{
                    fontWeight: "bold",
                    marginRight: "4px",
                    whiteSpace: "nowrap",
                  }}
                >
                  PER PAGE
                </Typography>
                <FormControl variant="outlined" size="small">
                  <Select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                  >
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                    <MenuItem value={200}>200</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Box
            style={{
              border: "1px solid #bdbdbd",
              padding: "1rem",
              // borderRadius: "0.5rem",
              paddingBottom: "1rem",
              marginTop: "1rem",
            }}
          >
            <Grid
              container
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <Grid item xs={12} sm={4}></Grid>
              <Grid item xs={12} sm={4} style={{ display: 'flex', alignItems: 'baseline', gap: "3px", justifyContent: "center" }}>
                <Typography
                  style={{
                    fontSize: "1.3rem",
                    fontWeight: 600,
                    // marginLeft: "10rem",
                    textAlign: 'center'
                  }}
                >
                  {inventoryToggleValue === "CMO" && "CMO "} Inventory Status
                </Typography>
                <Typography style={{
                  fontSize: "0.8rem",
                  fontWeight: 400,
                  // marginLeft: "10rem",
                  textAlign: 'center'
                }}
                > {inventorySyncTime ? `(Last updated on ${convertToLocaleDateTime(inventorySyncTime)})` : ""}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} style={{ display: 'flex', justifyContent: 'end', gap: '10px', alignItems: 'center' }}>
                {localStorage.collabType !== "CMO" && (
                  <Button
                    variant="contained"
                    style={{
                      borderRadius: "0.5rem",
                      // backgroundColor: "#286acf",
                      // color: "#fff",
                      fontSize: "0.875rem", // Adjust font size properly
                      // width: "15rem",
                      height: "2rem",
                      textTransform: "capitalize",

                    }}
                    onClick={handleViewInventoryToggle}
                  >
                    View {inventoryToggleValue === 'BMS' ? "CMO" : "BMS"} Inventory
                  </Button>
                )}
                {localStorage.collabType !== "CMO" && screenAccess?.screenAccess && featuresAccess?.reconcileInventory && (
                  <Button
                    variant="contained"
                    startIcon={<Add />}
                    style={{
                      borderRadius: "0.5rem",
                      backgroundColor: "#286acf",
                      color: "#fff",
                      fontSize: "0.875rem", // Adjust font size properly
                      // width: "15rem",
                      height: "2rem",
                      textTransform: "capitalize"
                    }}
                    onClick={handleOpenDialog}
                  >
                    Reconcile Inventory
                  </Button>
                )}
                {/* <Button
                  variant="outlined"
                  style={{
                    borderRadius: "0.5rem",
                    borderColor: "#286acf",
                    color: "#286acf",
                    fontSize: "0.875rem",
                    height: "2rem",
                    textTransform: "capitalize"
                  }}
                  onClick={() => setReconHistoryOpen(true)}
                >
                  View Reconciliation History
                </Button> */}
              </Grid>
            </Grid>
          </Box>

          <TableContainer
            component={Paper}
            style={{
              overflowX: "auto",
              overflowY: "auto",
              maxHeight: "500px",
              borderLeft: "1px solid #bdbdbd",
              borderRight: "1px solid #bdbdbd",
              borderBottom: "1px solid #bdbdbd",
              width: "100%",
            }}
          >
            <Table className={classes.table} stickyHeader>
              <TableHead

              // style={{
              //   backgroundColor: "#FFE4C2 ",
              //   border: "1px solid #ffab91",
              //   height: "15px",
              // }}
              >
                <TableRow>
                  <TableCell
                    style={{
                      width: "1%",
                      maxWidth: 0,
                      // overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  />
                  {/* MSYMPD-693 — the CMO Inventory view now follows the CMO
                      Inventory for PD FSD's own 12-column set and labels. The FSD
                      has no CMO organisation column, so it is kept for the BMS
                      view only. Old code (rendered unconditionally):
                      <CustomTableCell ...>
                        {localStorage.collabType === "CMO" ? "BMS" : "CMO"}
                      </CustomTableCell> */}
                  {inventoryToggleValue !== "CMO" && (
                    <CustomTableCell
                      scope="row"
                      align="left"
                      elementStyle={{
                        //  maxWidth: "0px"
                        width: "auto",
                        fontWeight: "bold",
                      }}
                    >
                      {localStorage.collabType === "CMO" ? "BMS" : "CMO"}
                    </CustomTableCell>
                  )}
                  {/* MSYMPD-693 — FSD column 1 'CMO - MFG Plant'. This was hidden
                      in the CMO view; the FSD lists it first, so it now renders in
                      both views and is relabelled for the CMO view. Old condition:
                      {(inventoryToggleValue !== "CMO" || localStorage.collabType === "CMO") && ( */}
                  <CustomTableCell
                    scope="row"
                    align="left"
                    elementStyle={{
                      // maxWidth: "0px"
                      width: "auto",
                      fontWeight: "bold",
                    }}
                  >
                    {inventoryToggleValue === "CMO" ? "CMO - MFG Plant" : "Plant ID"}
                  </CustomTableCell>

                  {(inventoryToggleValue !== "CMO" || localStorage.collabType === "CMO") && (
                    <CustomTableCell
                      scope="row"
                      align="left"
                      elementStyle={{
                        // maxWidth: "0px"
                        width: "auto",
                        fontWeight: "bold",
                      }}
                    >
                      Storage Location ID
                    </CustomTableCell>
                  )}

                  {/* MSYMPD-693 — FSD columns 2 and 3, both new in the CMO view.
                      Backed by cmo_inventory.materialCode / materialDescription and
                      material_mapping.material_type_id -> materialType, supplied by
                      the middleware (fetchInventoryData.js). */}
                  {inventoryToggleValue === "CMO" && (
                    <CustomTableCell
                      scope="row"
                      align="left"
                      elementStyle={{
                        width: "auto",
                        fontWeight: "bold",
                      }}
                    >
                      CMO Material Code / Description
                    </CustomTableCell>
                  )}
                  {inventoryToggleValue === "CMO" && (
                    <CustomTableCell
                      scope="row"
                      align="left"
                      elementStyle={{
                        width: "auto",
                        fontWeight: "bold",
                      }}
                    >
                      Material Type
                    </CustomTableCell>
                  )}
                  {/* FSD column 4 — label already matches, left as-is. */}
                  <CustomTableCell
                    scope="row"
                    align="left"
                    elementStyle={{
                      //  maxWidth: "0px"
                      width: "auto",
                      fontWeight: "bold",
                    }}
                  >
                    {localStorage.collabType !== "CMO" ? "BMS" : "CMO"} Material Code / Description
                  </CustomTableCell>
                  {/* MSYMPD-693 — FSD column 5 'BMS Material Batch Number'.
                      Old label: {localStorage.collabType !== "CMO" ? "BMS" : "CMO"} Batch Numbers */}
                  <CustomTableCell
                    scope="row"
                    align="left"
                    elementStyle={{
                      //  maxWidth: "0px"
                      width: "auto",
                      fontWeight: "bold",
                    }}
                  >
                    {inventoryToggleValue === "CMO"
                      ? "BMS Material Batch Number"
                      : `${localStorage.collabType !== "CMO" ? "BMS" : "CMO"} Batch Numbers`}
                  </CustomTableCell>
                  {inventoryToggleValue === "CMO" && (
                    <CustomTableCell
                      scope="row"
                      align="left"
                      elementStyle={{
                        //  maxWidth: "0px"
                        width: "auto",
                        fontWeight: "bold",
                      }}
                    >
                      {/* MSYMPD-693 — FSD column 6. Old label: CMO Batch Numbers */}
                      CMO Material Batch Number
                    </CustomTableCell>
                  )}
                  <CustomTableCell
                    scope="row"
                    align="right"
                    elementStyle={{
                      //  maxWidth: "0px"
                      width: "auto",
                      fontWeight: "bold",
                      whiteSpace: "normal",
                    }}
                  >
                    {/* MSYMPD-693 — FSD column 7. Old label: BMS On-hand Qty. Available */}
                    {inventoryToggleValue === "CMO"
                      ? "Batch Qty."
                      : "On-hand Qty. Available"}
                  </CustomTableCell>
                  {inventoryToggleValue === "CMO" && (
                    <CustomTableCell
                      scope="row"
                      align="right"
                      elementStyle={{
                        //  maxWidth: "0px"
                        width: "auto",
                        fontWeight: "bold",
                        whiteSpace: "normal",
                      }}
                    >
                      {/* MSYMPD-693 — FSD column 8. Old label: CMO On-hand Qty. Available */}
                      Approved Qty.
                    </CustomTableCell>
                  )}
                  <CustomTableCell
                    scope="row"
                    align="right"
                    elementStyle={{
                      //  maxWidth: "0px"
                      width: "auto",
                      fontWeight: "bold",
                      whiteSpace: "normal",
                    }}
                  >
                    {/* MSYMPD-693 — FSD column 9. Old label: BMS Net Qty. Available */}
                    {inventoryToggleValue === "CMO"
                      ? "Rejected Qty."
                      : "Net Qty. Available"}
                  </CustomTableCell>
                  <CustomTableCell
                    scope="row"
                    align="right"
                    elementStyle={{
                      //  maxWidth: "0px"
                      width: "auto",
                      fontWeight: "bold",
                      whiteSpace: "normal",
                    }}
                  >
                    {/* MSYMPD-693 — FSD column 10. Old label: BMS Allocated Qty. */}
                    {inventoryToggleValue === "CMO"
                      ? "Quarantine Qty."
                      : "Allocated Qty."}
                    {/* Quantity Committed */}
                  </CustomTableCell>
                  <CustomTableCell
                    scope="row"
                    align="left"
                    elementStyle={{
                      //  maxWidth: "0px"
                      width: "auto",
                      fontWeight: "bold",
                    }}
                  >
                    {/* MSYMPD-693 — FSD column 11. Old label: BMS UoM. The value
                        also changes: the CMO view shows the CMO UoM, not the BMS one. */}
                    {inventoryToggleValue === "CMO" ? "CMO UoM" : "UoM"}
                  </CustomTableCell>
                  {localStorage.collabType !== "CMO" && inventoryToggleValue === "BMS" &&
                    <CustomTableCell
                      scope="row"
                      align="left"
                      elementStyle={{
                        //  maxWidth: "0px"
                        width: "auto",
                        fontWeight: "bold",
                      }}
                    >
                      Date of Manufacturing
                    </CustomTableCell>
                  }
                  <CustomTableCell
                    scope="row"
                    align="left"
                    elementStyle={{
                      //  maxWidth: "0px"
                      width: "auto",
                      fontWeight: "bold",
                    }}
                  >
                    {/* MSYMPD-693 — FSD column 12 'CMO Retest Date', backed by
                        cmo_inventory.inventoryExpiryDate. Old label: BMS Expiry Date */}
                    {inventoryToggleValue === "CMO"
                      ? "CMO Retest Date"
                      : "Expiry Date"}
                  </CustomTableCell>
                </TableRow>
              </TableHead>
              {inventoryDataLoading === true ? (
                <TableRow style={{ height: 150 }}>
                  {/* MSYMPD-693 — the CMO view now renders 12 FSD columns plus the
                      expand spacer, so the spinner has to span 13 there.
                      Old value: colSpan={12} */}
                  <TableCell colSpan={inventoryToggleValue === "CMO" ? 13 : 12}>
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" thickness={7} />
                    </div>
                  </TableCell>
                </TableRow>
              ) : Array.isArray(inventoryList?.inventoryDataList) &&
                inventoryList?.totalNoOfRecords > 0 ? (
                <TableBody>
                  {paginatedData?.map((vendor, index) => (
                    <React.Fragment key={index}>
                      {paginatedData.length !== 1 && (
                        <TableRow style={{ width: "100%" }}>
                          <TableCell
                            size="small"
                            style={{
                              maxWidth: "0",
                              // overflow: "hidden",
                              whiteSpace: "nowrap",
                              width: "1%",
                              padding: 0,
                            }}
                          >
                            {vendor.lotNumbersList.length > 1 &&
                              <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => handleRowToggle(index)}
                              >
                                {openRows[index] ? (
                                  <ExpandMoreIcon />
                                ) : (
                                  <ChevronRightIcon />
                                )}
                              </IconButton>
                            }
                          </TableCell>
                          {/* MSYMPD-693 — CMO organisation column: BMS view only,
                              matching the header. */}
                          {inventoryToggleValue !== "CMO" && (
                            <CustomTableCell
                              scope="row"
                              align="left"
                              elementStyle={{ whiteSpace: "nowrap" }}
                            >
                              {localStorage.collabType === "CMO"
                                ? vendor.brandOwnerName
                                : vendor.vendorName}
                            </CustomTableCell>
                          )}
                          {/* MSYMPD-693 — FSD column 1 'CMO - MFG Plant', now shown
                              in both views. Old condition:
                              {(inventoryToggleValue !== "CMO" || localStorage.collabType === "CMO") && ( */}
                          <CustomTableCell
                            scope="row"
                            align="left"
                            elementStyle={{ whiteSpace: "nowrap" }}
                          >
                            {vendor.vendorPlant}
                          </CustomTableCell>
                          {(inventoryToggleValue !== "CMO" || localStorage.collabType === "CMO") && (
                            <CustomTableCell
                              scope="row"
                              align="left"
                              elementStyle={{ whiteSpace: "nowrap" }}
                            >
                              {/* Storage Location ID */}
                              {vendor.storageLocationID}
                            </CustomTableCell>
                          )}
                          {/* MSYMPD-693 — FSD columns 2 and 3. */}
                          {inventoryToggleValue === "CMO" && (
                            <CustomTableCell
                              scope="row"
                              align="left"
                              elementStyle={{
                                maxWidth: "0px",
                                whiteSpace: "break-spaces",
                              }}
                            >
                              {vendor.lotNumbersList.length === 1
                                ? `${vendor.lotNumbersList[0]?.cmoMaterialCode || "NA"} / ${vendor.lotNumbersList[0]?.cmoMaterialDescription || "NA"}`
                                : ""}
                            </CustomTableCell>
                          )}
                          {inventoryToggleValue === "CMO" && (
                            <CustomTableCell
                              scope="row"
                              align="left"
                              elementStyle={{ whiteSpace: "nowrap" }}
                            >
                              {vendor?.materialType || "NA"}
                            </CustomTableCell>
                          )}
                          <CustomTableCell
                            scope="row"
                            align="left"
                            elementStyle={{
                              maxWidth: "0px",
                              whiteSpace: "break-spaces",
                            }}
                          >
                            {/* MSYMPD-693 — in the CMO view this database field
                                holds the CMO's own material code (Field Mapping),
                                so showing it here would just repeat the CMO
                                Material Code column. It reads 'N/A' instead. */}
                            {inventoryToggleValue === "CMO"
                              ? "N/A"
                              : `${vendor?.materialCode || "NA"} / ${vendor?.materialDescription || "NA"}`}
                          </CustomTableCell>
                          <CustomTableCell
                            scope="row"
                            align="left"
                            elementStyle={{ whiteSpace: "nowrap" }}
                          >
                            {vendor.lotNumbersList.length === 1 &&
                              <React.Fragment>
                                {vendor.lotNumbersList[0].lotNumber || "NA"}
                                {vendor.lotNumbersList[0]?.batchExpired === true ? (
                                  <FlagIcon
                                    style={{
                                      color: "red",
                                      fontSize: 28, // Small size
                                      stroke: "black", // Outline color
                                      strokeWidth: 1.3, // Adjust for thinness
                                    }}
                                  />
                                ) : vendor.lotNumbersList[0]?.batchNearExpiry ? (
                                  <FlagIcon
                                    style={{
                                      color: "yellow",
                                      fontSize: 28, // Small size
                                      stroke: "black", // Outline color
                                      strokeWidth: 1.3, // Adjust for thinness
                                    }}
                                  />
                                ) : null}
                              </React.Fragment>
                            }

                            {/* {vendor?.latestInventoryUpdatedDate ? (
                            <>
                              <Typography style={{ fontSize: "0.9rem" }}>
                                Last updated on @
                              </Typography>
                              <Typography style={{ fontSize: "0.8rem" }}>
                                {convertToLocaleDateTime(
                                  vendor?.latestInventoryUpdatedDate
                                ).toUpperCase()}
                              </Typography>
                            </>
                          ) : (
                            <Typography>NA</Typography>
                          )} */}
                          </CustomTableCell>
                          {/* CMO Batch Number */}
                          {inventoryToggleValue === "CMO" && (
                            <CustomTableCell
                              scope="row"
                              align="left"
                              elementStyle={{ whiteSpace: "nowrap" }}
                            >
                              {vendor.lotNumbersList.length === 1 &&
                                <React.Fragment>
                                  {vendor.lotNumbersList[0].cmoLotNumber || "NA"}
                                  {vendor.lotNumbersList[0]?.cmoBatchExpired === true ? (
                                    <FlagIcon
                                      style={{
                                        color: "red",
                                        fontSize: 28, // Small size
                                        stroke: "black", // Outline color
                                        strokeWidth: 1.3, // Adjust for thinness
                                      }}
                                    />
                                  ) : vendor.lotNumbersList[0]?.cmoBatchNearExpiry ? (
                                    <FlagIcon
                                      style={{
                                        color: "yellow",
                                        fontSize: 28, // Small size
                                        stroke: "black", // Outline color
                                        strokeWidth: 1.3, // Adjust for thinness
                                      }}
                                    />
                                  ) : null}
                                </React.Fragment>
                              }
                            </CustomTableCell>
                          )}
                          <CustomTableCell
                            scope="row"
                            align="right"
                            elementStyle={{ whiteSpace: "nowrap" }}
                          >

                            {vendor.lotNumbersList.length === 1 ?
                              vendor.lotNumbersList[0]?.onHandAvailableQuantity
                                ? (
                                  Math.ceil(
                                    vendor.lotNumbersList[0].onHandAvailableQuantity * 1000
                                  ) / 1000
                                ).toFixed(3)
                                : "0"
                              : ""}
                            {/* {vendor?.totalOnHandQuantity
                            ? (
                              Math.ceil(vendor.totalOnHandQuantity * 1000) /
                              1000
                            ).toFixed(3)
                            : "0"} */}
                          </CustomTableCell>
                          {/* CMO on hand total qty */}
                          {inventoryToggleValue === "CMO" && (
                            <CustomTableCell
                              scope="row"
                              align="right"
                              elementStyle={{ whiteSpace: "nowrap" }}
                            >

                              {vendor.lotNumbersList.length === 1 ?
                                vendor.lotNumbersList[0]?.cmoOnHandAvailableQuantity
                                  ? (
                                    Math.ceil(
                                      vendor.lotNumbersList[0].cmoOnHandAvailableQuantity * 1000
                                    ) / 1000
                                  ).toFixed(3)
                                  : "0"
                                : ""}
                              {/* {vendor?.totalOnHandQuantity
                            ? (
                              Math.ceil(vendor.totalOnHandQuantity * 1000) /
                              1000
                            ).toFixed(3)
                            : "0"} */}
                            </CustomTableCell>
                          )}
                          <CustomTableCell
                            scope="row"
                            align="right"
                            elementStyle={{ whiteSpace: "nowrap" }}
                          >

                            {vendor.lotNumbersList.length === 1 ? vendor.lotNumbersList[0]?.netAvailableQuantity
                              ? (
                                Math.ceil(
                                  vendor.lotNumbersList[0].netAvailableQuantity * 1000
                                ) / 1000
                              ).toFixed(3)
                              : "0"
                              : ""}
                            {/* {vendor?.totalNetAvailableQuantity
                            ? (
                              Math.ceil(
                                vendor.totalNetAvailableQuantity * 1000
                              ) / 1000
                            ).toFixed(3)
                            : "0"} */}
                          </CustomTableCell>
                          <CustomTableCell
                            scope="row"
                            align="right"
                            elementStyle={{ whiteSpace: "nowrap" }}
                          >
                            {vendor.lotNumbersList.length === 1 ? vendor.lotNumbersList[0]?.committedQuantity
                              ? (
                                Math.ceil(vendor.lotNumbersList[0].committedQuantity * 1000) /
                                1000
                              ).toFixed(3)
                              : "0"
                              : ""}
                            {/* {vendor?.totalCommittedQuantity
                            ? (
                              Math.ceil(
                                vendor.totalCommittedQuantity * 1000
                              ) / 1000
                            ).toFixed(3)
                            : "0"} */}
                          </CustomTableCell>
                          <CustomTableCell
                            scope="row"
                            align="left"
                            elementStyle={{ whiteSpace: "nowrap" }}
                          >
                            {/* MSYMPD-693 — FSD column 11 shows the CMO UoM, not the
                                BMS one, in the CMO view. Old value:
                                {vendor.lotNumbersList.length === 1 ? vendor.lotNumbersList[0]?.inventoryUOM || "" : ""} */}
                            {vendor.lotNumbersList.length === 1
                              ? inventoryToggleValue === "CMO"
                                ? vendor.lotNumbersList[0]?.cmoInventoryUOM || "NA"
                                : vendor.lotNumbersList[0]?.inventoryUOM || ""
                              : ""}

                          </CustomTableCell>
                          {localStorage.collabType !== "CMO" && inventoryToggleValue === "BMS" &&
                            <CustomTableCell
                              scope="row"
                              align="left"
                              elementStyle={{ maxWidth: "0px", whiteSpace: "nowrap", overflow: 'visible' }}
                            >
                              {vendor.lotNumbersList.length === 1 ? vendor.lotNumbersList[0]?.inventoryManufacturingDate
                                ? moment(vendor.lotNumbersList[0]?.inventoryManufacturingDate).format(
                                  "DD-MMM-YYYY"
                                ).toUpperCase()
                                : ""
                                : ""}

                            </CustomTableCell>
                          }
                          <CustomTableCell
                            scope="row"
                            align="left"
                            elementStyle={{ maxWidth: "0px", whiteSpace: "nowrap", overflow: 'visible' }}
                          >
                            {/* MSYMPD-693 — FSD column 12 'CMO Retest Date' reads
                                cmo_inventory.inventoryExpiryDate in the CMO view.
                                Old value:
                                {vendor.lotNumbersList.length === 1 ? vendor.lotNumbersList[0]?.expiryDate
                                  ? moment(vendor.lotNumbersList[0]?.expiryDate).format("DD-MMM-YYYY").toUpperCase()
                                  : "" : ""} */}
                            {vendor.lotNumbersList.length === 1
                              ? inventoryToggleValue === "CMO"
                                ? vendor.lotNumbersList[0]?.cmoExpiryDate
                                  ? moment(vendor.lotNumbersList[0]?.cmoExpiryDate).format(
                                    "DD-MMM-YYYY"
                                  ).toUpperCase()
                                  : "NA"
                                : vendor.lotNumbersList[0]?.expiryDate
                                  ? moment(vendor.lotNumbersList[0]?.expiryDate).format(
                                    "DD-MMM-YYYY"
                                  ).toUpperCase()
                                  : ""
                              : ""}

                          </CustomTableCell>
                        </TableRow>
                      )
                      }

                      {((openRows[index] && vendor.lotNumbersList.length > 1) || paginatedData.length === 1) && (
                        <React.Fragment>
                          {vendor.lotNumbersList.map((lot, lotIndex) => (
                            <TableRow
                              key={lotIndex}
                            // style={{ marginRight: "5rem" }}
                            >
                              <TableCell
                                style={{
                                  width: "1%",
                                  maxWidth: 0,
                                  // overflow: "hidden",
                                  whiteSpace: "nowrap",
                                }}
                              ></TableCell>
                              {/* MSYMPD-693 — CMO organisation column: BMS view only. */}
                              {inventoryToggleValue !== "CMO" && (
                                <CustomTableCell
                                  scope="row"
                                  align="left"
                                  elementStyle={{ whiteSpace: "nowrap" }}
                                >
                                  {lot.vendorName}
                                  {/* {localStorage.collabType === "CMO"
                                    ? vendor.brandOwnerName
                                    : vendor.vendorName} */}
                                </CustomTableCell>
                              )}
                              {/* MSYMPD-693 — FSD column 1, now shown in both views.
                                  Old condition:
                                  {(inventoryToggleValue !== "CMO" || localStorage.collabType === "CMO") && ( */}
                              <CustomTableCell
                                scope="row"
                                align="left"
                                elementStyle={{ whiteSpace: "nowrap" }}
                              >
                                {lot.vendorPlant}
                              </CustomTableCell>
                              {(inventoryToggleValue !== "CMO" || localStorage.collabType === "CMO") && (
                                <CustomTableCell
                                  scope="row"
                                  align="left"
                                  elementStyle={{ whiteSpace: "nowrap" }}
                                >
                                  {/* Storage Location ID */}
                                  {vendor.storageLocationID}
                                </CustomTableCell>
                              )}
                              {/* MSYMPD-693 — FSD columns 2 and 3. */}
                              {inventoryToggleValue === "CMO" && (
                                <CustomTableCell
                                  scope="row"
                                  align="left"
                                  elementStyle={{ whiteSpace: "break-spaces" }}
                                >
                                  {`${lot?.cmoMaterialCode || "NA"} / ${lot?.cmoMaterialDescription || "NA"}`}
                                </CustomTableCell>
                              )}
                              {inventoryToggleValue === "CMO" && (
                                <CustomTableCell
                                  scope="row"
                                  align="left"
                                  elementStyle={{ whiteSpace: "nowrap" }}
                                >
                                  {vendor?.materialType || "NA"}
                                </CustomTableCell>
                              )}
                              <CustomTableCell
                                scope="row"
                                align="left"
                                elementStyle={{ whiteSpace: "break-spaces" }}
                              >
                                {/* MSYMPD-693 — 'N/A' in the CMO view, as above. */}
                                {inventoryToggleValue === "CMO"
                                  ? "N/A"
                                  : `${vendor?.materialCode || "NA"} / ${vendor?.materialDescription || "NA"}`}
                              </CustomTableCell>
                              <CustomTableCell
                                scope="row"
                                align="left"
                                elementStyle={{ whiteSpace: "nowrap" }}
                              >
                                {lot.lotNumber || "NA"}
                                {lot?.batchExpired === true ? (
                                  <FlagIcon
                                    style={{
                                      color: "red",
                                      fontSize: 28, // Small size
                                      stroke: "black", // Outline color
                                      strokeWidth: 1.3, // Adjust for thinness
                                    }}
                                  />
                                ) : lot?.batchNearExpiry ? (
                                  <FlagIcon
                                    style={{
                                      color: "yellow",
                                      fontSize: 28, // Small size
                                      stroke: "black", // Outline color
                                      strokeWidth: 1.3, // Adjust for thinness
                                    }}
                                  />
                                ) : null}
                              </CustomTableCell>
                              {/* CMO Batch Number */}
                              {inventoryToggleValue === "CMO" && (
                                <CustomTableCell
                                  scope="row"
                                  align="left"
                                  elementStyle={{ whiteSpace: "nowrap" }}
                                >
                                  {lot.cmoLotNumber || "NA"}
                                  {lot?.cmoBatchExpired === true ? (
                                    <FlagIcon
                                      style={{
                                        color: "red",
                                        fontSize: 28, // Small size
                                        stroke: "black", // Outline color
                                        strokeWidth: 1.3, // Adjust for thinness
                                      }}
                                    />
                                  ) : lot?.cmoBatchNearExpiry ? (
                                    <FlagIcon
                                      style={{
                                        color: "yellow",
                                        fontSize: 28, // Small size
                                        stroke: "black", // Outline color
                                        strokeWidth: 1.3, // Adjust for thinness
                                      }}
                                    />
                                  ) : null}
                                </CustomTableCell>
                              )}
                              <CustomTableCell
                                scope="row"
                                align="right"
                                elementStyle={{ whiteSpace: "nowrap" }}
                              >
                                {/* {lot?.onHandAvailableQuantity || "NA"} */}
                                {lot?.onHandAvailableQuantity
                                  ? (
                                    Math.ceil(
                                      lot.onHandAvailableQuantity * 1000
                                    ) / 1000
                                  ).toFixed(3)
                                  : "0"}
                              </CustomTableCell>
                              {/* CMO on hands total qty */}
                              {inventoryToggleValue === "CMO" && (
                                <CustomTableCell
                                  scope="row"
                                  align="right"
                                  elementStyle={{ whiteSpace: "nowrap" }}
                                >
                                  {/* {lot?.onHandAvailableQuantity || "NA"} */}
                                  {lot?.cmoOnHandAvailableQuantity
                                    ? (
                                      Math.ceil(
                                        lot.cmoOnHandAvailableQuantity * 1000
                                      ) / 1000
                                    ).toFixed(3)
                                    : "0"}
                                </CustomTableCell>
                              )}
                              <CustomTableCell
                                scope="row"
                                align="right"
                                elementStyle={{ whiteSpace: "nowrap" }}
                              >
                                {/* {lot?.netAvailableQuantity || "NA"}
                                 */}
                                {lot?.netAvailableQuantity
                                  ? (
                                    Math.ceil(
                                      lot.netAvailableQuantity * 1000
                                    ) / 1000
                                  ).toFixed(3)
                                  : "0"}
                              </CustomTableCell>
                              <CustomTableCell
                                scope="row"
                                align="right"
                                elementStyle={{ whiteSpace: "nowrap" }}
                              >
                                {/* {lot?.committedQuantity || "NA"} */}
                                {lot?.committedQuantity
                                  ? (
                                    Math.ceil(lot.committedQuantity * 1000) /
                                    1000
                                  ).toFixed(3)
                                  : "0"}
                              </CustomTableCell>
                              <CustomTableCell
                                scope="row"
                                align="left"
                                elementStyle={{ whiteSpace: "nowrap" }}
                              >
                                {/* MSYMPD-693 — FSD column 11 shows the CMO UoM in
                                    the CMO view. Old value: {lot?.inventoryUOM || ""} */}
                                {inventoryToggleValue === "CMO"
                                  ? lot?.cmoInventoryUOM || "NA"
                                  : lot?.inventoryUOM || ""}
                              </CustomTableCell>
                              {localStorage.collabType !== "CMO" && inventoryToggleValue === "BMS" &&
                                <CustomTableCell
                                  scope="row"
                                  align="left"
                                  elementStyle={{ whiteSpace: "nowrap", overflow: 'visible' }}
                                >
                                  {lot?.inventoryManufacturingDate
                                    ? moment(lot?.inventoryManufacturingDate).format(
                                      "DD-MMM-YYYY"
                                    ).toUpperCase()
                                    : ""}
                                </CustomTableCell>
                              }
                              <CustomTableCell
                                scope="row"
                                align="left"
                                elementStyle={{ whiteSpace: "nowrap", overflow: 'visible' }}
                              >
                                {/* MSYMPD-693 — FSD column 12 'CMO Retest Date' reads
                                    cmo_inventory.inventoryExpiryDate in the CMO view.
                                    Old value:
                                    {lot?.expiryDate
                                      ? moment(lot?.expiryDate).format("DD-MMM-YYYY").toUpperCase()
                                      : ""} */}
                                {inventoryToggleValue === "CMO"
                                  ? lot?.cmoExpiryDate
                                    ? moment(lot?.cmoExpiryDate).format(
                                      "DD-MMM-YYYY"
                                    ).toUpperCase()
                                    : "NA"
                                  : lot?.expiryDate
                                    ? moment(lot?.expiryDate).format(
                                      "DD-MMM-YYYY"
                                    ).toUpperCase()
                                    : ""}
                              </CustomTableCell>
                            </TableRow>
                          ))}
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ))}
                </TableBody>
              ) : inventoryData?.status === false ? (
                <TableRow
                  style={{
                    border: "2px solid rgb(255,0,0)",
                    backgroundColor: "rgb(255,240,240)",
                    Opacity: 1,
                    textAlign: "center",
                    padding: "0.8rem",
                    fontSize: "0.875rem",
                  }}
                >
                  <TableCell colSpan={10} align="center">
                    {"Something went wrong. Please contact Schrocken Support."}
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>

          {showPagination === true && inventoryDataLoading === false && (
            <Box
              style={{
                marginTop: 24,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingRight: "2rem",
              }}
            >
              <IconButton
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                <ChevronLeft />
              </IconButton>
              <Typography style={{ margin: "0 16px" }}>
                Page {currentPage} of {totalPages}
              </Typography>
              <IconButton
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                <ChevronRight />
              </IconButton>
            </Box>
          )}
        </>
      )}

      {openDialog && (
        <InventoryStatusPopup
          open={openDialog}
          onClose={handleCloseDialog}
          setReconDialog={setReconDialog}
          cmosList={cmosList}
          plantCodesList={plantCodesList}
          setVendorData={setVendorData}
          initialSelectedCMO={selectedCMO}
          sponsorLastUpdatedDate={inventoryData?.sponsorLatestInventorySyncTime}
        />
      )}
      <Dialog open={reconDialog} fullScreen>
        <InventoryReconciliation
          setReconDialog={setReconDialog}
          vendorData={vendorData}
        />
      </Dialog>
    </div>
  );
};

export default InventoryStatusDashboard;
